import React from "react"
import { useAppSelector } from "../../../../../app/hooks"
import { TextField } from "@mui/material";
import { formatNumber } from "@progress/kendo-intl";

function AccountRoomChargesView(){
    const account = useAppSelector((state) => state.account.account);
    return <React.Fragment>
        <TextField label='Room Charges' 
            value={formatNumber(account.transactionHeader.roomCharges,'c')}
            disabled
            />
    </React.Fragment>
}
export {AccountRoomChargesView}